import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'dubbingErrorEmptySegments',
  'emptySegmentsDeleteAllClicked',
  'modalDeleteAllEmptySegmentsOpened',
] as const;

export const projectEvents = getMappedEvents([...EVENTS]);
